import {defineStore} from "pinia"
import axios from "@/app/axios.ts"

const translationsData = window.translationsData

export const usePackageStore = defineStore("package", {
    state: () => ({
        lang: translationsData?.global_route?.locale || "de",
        t: translationsData?.translations?.frontend || {},
        packageId: document.body.getAttribute("data-package-id"),
        contentsNeedUpdate: true,
        authUser: null,
        isAuthUser: null,
        limits: null,
        canAccess: null,
        contents: [],
        isLoading: false,
        loadPromise: null
    }),

    getters: {
        getPackageId: (state) => () => state.packageId || null,
        getContentById: (state) => (id) => {
            return state.contents?.find((item) => item.id === id) || null
        },
        getAuthUser: (state) => () => state.authUser || null,
        getIsAuthUser: (state) => () => state.isAuthUser || null,
        getLimits: (state) => () => state.limits || null,
        getCanAccess: (state) => () => state.canAccess || null
    },
    actions: {
        async fetchPackageContentsData() {
            if (!this.contentsNeedUpdate || this.isLoading) {
                return this.loadPromise
            }

            if (!this.packageId) {
                console.warn("Invalid or empty packageId provided to fetchPackageContentsData")
                return
            }

            this.isLoading = true

            const headers = {
                "Content-Type": "application/json; charset=UTF-8",
                "X-CSRF-TOKEN": document.querySelector("meta[name=csrf-token]").content,
                "X-Robots-Tag": "noindex, nofollow"
            }

            this.loadPromise = axios
                .post(
                    `/${this.lang}/package/get-contents/${this.packageId}`,
                    {id: this.packageId},
                    {
                        headers: headers
                    }
                )
                .then((response) => {
                    this.authUser = response.data.authUser
                    this.isAuthUser = !!response.data.authUser
                    this.limits = response.data.limits
                    this.canAccess = response.data.canAccess
                    this.contentsNeedUpdate = false

                    if (response.data.contents && Array.isArray(response.data.contents)) {
                        this.contents = response.data.contents
                    } else {
                        console.warn("Unexpected response format: expected array", response)
                    }
                })
                .catch((error) => {
                    console.error("Error fetching content data:", error)
                })
                .finally(() => {
                    this.isLoading = false
                })

            return this.loadPromise
        }
    }
})
